import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'invopay/admin/login-admin',
    pathMatch: 'full',
  },
  {
    path: 'invopay/admin',
    redirectTo: 'invopay/admin/login-admin',
    pathMatch: 'full',
  },
  {
    path: 'invopay/admin',
    loadChildren: () =>
      import('./invopay/invopay.module').then((m) => m.InvopayModule),
  },
  {
    path: 'invopay/admin/**',
    redirectTo: 'invopay/admin/login-admin'
  },
  {
    path: 'invopay/**',
    redirectTo: 'invopay/admin/login-admin'
  },
  {
    path: '**',
    redirectTo: 'invopay/admin/login-admin'
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
